import { g as se, T as ie } from "./chunks/Tooltip.b53afcfb.js";
import { B as H } from "./chunks/BodyScrollLock.f247d772.js";
import { F as uo } from "./chunks/BodyScrollLock.f247d772.js";
import { C as le } from "./chunks/index.cf4295be.js";
import { _ as fo, S as po, a as mo, g as vo, h as _o } from "./chunks/index.cf4295be.js";
import { P as ue } from "./chunks/index.8bf24338.js";
import { c as go, B as bo, _ as yo, d as Io, f as wo, g as ko, i as xo, h as Lo, e as Co, b as Mo, a as To, j as Eo, m as Oo, k as So, l as Bo, u as Fo } from "./chunks/index.8bf24338.js";
import { E as ce } from "./chunks/index.053d2b9b.js";
import { _ as Do } from "./chunks/index.053d2b9b.js";
import { D as de } from "./chunks/index.d2500874.js";
import { _ as zo, E as Po } from "./chunks/index.d2500874.js";
import { g as fe } from "./chunks/getDataEventValue.a20ca383.js";
import pe from "dompurify";
import me from "mitt";
import { useDebounceFn as ve } from "@vueuse/core";
import { ref as m, defineComponent as M, openBlock as l, createElementBlock as d, withModifiers as _e, createStaticVNode as he, computed as h, normalizeClass as B, createElementVNode as v, createBlock as I, toDisplayString as $, onMounted as N, createVNode as y, withCtx as W, Fragment as P, renderList as R, watch as D, onBeforeUnmount as ge, unref as w, createCommentVNode as C, onUnmounted as be, withDirectives as j, withKeys as ye, renderSlot as Ie, vModelText as we } from "vue";
import { g as q, _ as Y, a as G, b as K, c as ke, N as xe } from "./chunks/index.4b3376bf.js";
import { d as No, e as Vo } from "./chunks/index.4b3376bf.js";
import { U as Le } from "./chunks/UserService.0c09feb8.js";
import { s as Wo } from "./chunks/UserService.0c09feb8.js";
import { $ as F } from "./chunks/FrontiersClibConfigService.5b50b8d0.js";
import { Accordion as Ho, AccordionItem as jo } from "./accordion.es.js";
import { _ as Go, g as Ko } from "./chunks/index.ed7e1cd9.js";
import { Avatar as Qo, AvatarColor as Zo, AvatarSize as Xo } from "./avatar.es.js";
import { Breadcrumbs as tn } from "./breadcrumbs.es.js";
import { Button as nn, ButtonColor as an, ButtonIconLocation as rn, ButtonSize as sn, ButtonType as ln } from "./button.es.js";
import { _ as cn, a as dn, d as fn, c as pn, b as mn, L as vn } from "./chunks/CustomLink.vue_vue_type_style_index_0_lang.c7d27b7c.js";
import { _ as hn, t as gn } from "./chunks/index.a04d635b.js";
import { Footer as yn } from "./footer.es.js";
import { _ as wn, a as kn, F as xn, t as Ln } from "./chunks/FrontiersImage.vue_vue_type_script_setup_true_lang.2836b6c7.js";
import "./frontiersImage.es.js";
import { FrontiersVideo as Mn, VideoProvider as Tn, VideoRatio as En } from "./frontiersVideo.es.js";
import { QuickFilters as Sn, QuickFiltersItem as Bn } from "./quickFilters.es.js";
import { SocialMediaFeed as $n, SocialMediaFeedEmit as Dn, SocialMediaFeedProvider as An } from "./socialMediaFeed.es.js";
import { TagCloud as Pn, TagCloudHeadingsEnum as Rn } from "./tagCloud.es.js";
import { Pagination as Vn } from "./pagination.es.js";
import { _ as Wn } from "./chunks/Card.vue_vue_type_script_setup_true_lang.d829b19e.js";
import './assets/Card.css';import './assets/main.css';/* empty css                                                      */import { ImageViewer as Hn } from "./imageViewer.es.js";
import { MainHeader as Yn, MainHeaderEnum as Gn } from "./mainHeader.es.js";
import { CardEditor as Jn } from "./cardEditor.es.js";
import { CardSubject as Zn } from "./cardSubject.es.js";
import { GoogleRecaptcha as ea } from "./googleRecaptcha.es.js";
import { Alert as oa, AlertType as na } from "./alert.es.js";
import { CreateCommonOrganization as ra, CreateOrganization as sa, OrganizationType as ia, UgaritInput as la, UgaritService as ua } from "./ugaritInput.es.js";
import { CardA as da, CardASkin as fa } from "./cardA.es.js";
import { Banner as ma } from "./banner.es.js";
import { Carousel as _a } from "./carousel.es.js";
import { FilterCardListB as ga } from "./filterCardListB.es.js";
import { MessagesCarousel as ya, MessagesCarouselItem as Ia } from "./messagesCarousel.es.js";
import { Newsletter as ka } from "./newsletter.es.js";
import { ButtonIcon as La, ButtonIconColor as Ca, ButtonIconSize as Ma } from "./buttonIcon.es.js";
import { Tag as Ea } from "./tag.es.js";
import { Snackbar as Sa, SnackbarManager as Ba, clearAllSnackbarNotification as Fa, createSnackbarNotification as $a } from "./snackbar.es.js";
import { Tabs as Aa } from "./tabs.es.js";
import { Spinner as Pa } from "./spinner.es.js";
import { ChipFilter as Na } from "./chipFilter.es.js";
import { _ as Ua, a as Wa } from "./chunks/index.849d0934.js";
import { Segment as Ha } from "./segment.es.js";
import { _ as J } from "./chunks/_plugin-vue_export-helper.dad06003.js";
import { debounce as Ce } from "ts-debounce";
import { R as Q } from "./chunks/Resolutions.98ea1054.js";
import { OnClickOutside as Me } from "@vueuse/components";
import { CardDownload as Ya, CardGrid as Ga, CardPostNew as Ka, CardRT as Ja } from "./cards.es.js";
import { ValidationMessage as Te } from "./validationMessage.es.js";
import { F as Za } from "./chunks/FrontiersIcon.fac4da01.js";
import { SearchBar as er } from "./searchBar.es.js";
import { Input as or } from "./input.es.js";
import { CardArticle as ar } from "./cardArticle.es.js";
import { _ as sr, f as ir, g as lr } from "./chunks/index.bb65e9d2.js";
import { _ as cr } from "./chunks/CardB.vue_vue_type_style_index_0_lang.5dcb778a.js";
import { RadioInputList as fr } from "./radioInputList.es.js";
import { FeedbackIcon as mr } from "./feedbackIcon.es.js";
import { SlidingPanel as _r } from "./slidingPanel.es.js";
import { b as gr, e as br, d as yr, g as Ir, c as wr, m as kr, a as xr, p as Lr } from "./chunks/calendarHelper.9c81d081.js";
import { E as Mr } from "./chunks/EnumParser.dab943ef.js";
import { g as Er, l as Or } from "./chunks/linkClickHandler.d9801523.js";
import { gsap as z } from "gsap";
import { a as Br, i as Fr } from "./chunks/Numbers.0dd1fb08.js";
import { f as Dr } from "./chunks/CardMetricList.vue_vue_type_script_setup_true_lang.a398feed.js";
function Ht(e) {
  return e ? `${e.firstName[0]}${e.lastName[0]}`.toUpperCase() : "";
}
function jt(e) {
  const o = e % 10, t = e % 100;
  return o === 1 && t !== 11 ? e + "st" : o === 2 && t !== 12 ? e + "nd" : o === 3 && t !== 13 ? e + "rd" : e + "th";
}
function Yt(e) {
  if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
    const o = document.createElement("textarea");
    o.textContent = e, o.style.position = "fixed", document.body.appendChild(o), o.select();
    try {
      return document.execCommand("copy");
    } catch {
      return !1;
    } finally {
      document.body.removeChild(o);
    }
  }
}
function Ee() {
  return {
    ALLOWED_TAGS: [
      "img",
      "ul",
      "li",
      "ol",
      "u",
      "i",
      "em",
      "mark",
      "strong",
      "i",
      "p",
      "a",
      "div",
      "br",
      "sup",
      "sub"
    ],
    ALLOWED_ATTR: ["href", "target", "src", "alt"],
    ALLOW_DATA_ATTR: !1
  };
}
function Gt(e, o, t) {
  const a = q(e.hash), n = q(o.hash);
  if (a) {
    const i = document.querySelector(`${a}`);
    if (i) {
      const r = i.offsetTop, f = window.scrollY;
      var s = Math.abs(r - f);
      const u = Math.min(2, Math.max(s / 3e3, 0.24));
      if (a === n && s < t + 10) {
        setTimeout(function() {
          z.set(window, {
            scrollTo: {
              y: a,
              offsetY: t
            }
          });
        }, 1);
        return;
      }
      setTimeout(() => {
        z.set(window, {
          scrollTo: {
            y: f
          }
        }), z.to(window, {
          duration: u,
          scrollTo: {
            y: a,
            offsetY: t
          },
          ease: "Power2.out"
        });
      }, 1);
    }
  } else
    z.to(window, {
      duration: 1,
      ease: "power2",
      scrollTo: 0
    });
}
function Kt(e) {
  typeof window > "u" || (window.FRONTIERS || (window.FRONTIERS = {}), Object.assign(window.FRONTIERS, { [e.name]: e.version }));
}
function Jt(e) {
  let o = !0, t = e;
  for (; t.parentElement != null; )
    if (t = t.parentElement, t.tagName === "BODY") {
      o = !1;
      break;
    }
  return o ? t : null;
}
function Qt(e, o = 10, t = 100, a = !1) {
  return new Promise((n, s) => {
    let i = 0;
    const r = setInterval(() => {
      e() === !0 ? (clearInterval(r), n()) : i > o ? (clearInterval(r), a ? s(
        new Error(
          `Condition not matched in ${t * o} milliseconds`
        )
      ) : n()) : i += 1;
    }, t);
  });
}
function Zt(e, o) {
  const t = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "K" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "B" }
  ], a = /\.0+$|(\.[0-9]*[1-9])0+$/, n = t.slice().reverse().find(function(s) {
    return e >= s.value;
  });
  return n ? ((e / n.value).toFixed(o).replace(a, "$1") + n.symbol).replace(".", ",") : "0";
}
function Xt(e) {
  const o = new Date(e), t = 60, a = 120, n = o.getMonth() + 1, s = o.getDate(), i = n > 3 && n < 10 || n === 3 && s > 24 || n === 10 && s < 24, r = i ? a : t;
  return o.setMinutes(o.getMinutes() + r), {
    cetDate: o.toISOString().replace("T", " ").substring(0, 19),
    timeZone: i ? "CEST" : "CET"
  };
}
const eo = () => {
  const e = document.createElement("div");
  e.style.width = "100px", e.style.height = "100px", e.style.overflow = "scroll", e.style.position = "absolute", e.style.top = "-9999px", document.body.appendChild(e);
  const o = e.offsetWidth - e.clientWidth;
  return document.body.removeChild(e), o;
};
function Oe(e) {
  return /^[a-z][a-z\d+\-.]*:\/\//i.test(e);
}
function Se(e) {
  return !Oe(e);
}
function Be(e, o) {
  try {
    const t = new URL(e);
    return t.hostname === o || t.hostname.endsWith(`.${o}`);
  } catch {
    return !1;
  }
}
const to = (e) => Se(e) || Be(
  e,
  F.getMainDomain
) ? "_self" : "_blank", Z = {
  rootMargin: "0px 0px 0px 0px",
  threshold: [0, 1]
}, L = "FloatingDirectiveElement", Fe = (e, o, t) => {
  e.targetElIntersectionObserver = new IntersectionObserver(
    o,
    Z
  );
  let a = e;
  if (t.value && (a = document.querySelector(`#${t.value}`)), !a)
    throw new Error(
      "[directive:float] a binding value has been set, but there is no HTML element with the specified id"
    );
  e.targetElIntersectionObserver.observe(a), e.copiedEl && e.targetElIntersectionObserver.observe(e.copiedEl);
}, $e = (e, o) => {
  if (!e.floatingEl)
    return;
  o.value ? e.floatingEl.appendChild(e) : (e.originalParentEl = e.parentElement, e.copiedEl = e.cloneNode(!0), e.transitioning = !1, e.floatingEl.appendChild(e.copiedEl)), De(e.floatingEl, o.modifiers);
  let t = document.querySelector("footer");
  t || (t = se("floating")), t.appendChild(e.floatingEl);
}, De = (e, o) => {
  e.classList.add(L), o.left && e.classList.add(`${L}--left`), o.center && e.classList.add(`${L}--center`);
}, Ae = (e, o) => {
  const t = document.querySelector("footer");
  t && (e.footerIntersectionObserver = new IntersectionObserver(
    o,
    Z
  ), e.footerIntersectionObserver.observe(t));
}, ze = {
  mounted(e, o) {
    e.floatingEl = document.createElement("div");
    function t(n) {
      const s = e, i = e.copiedEl, r = e.originalParentEl, f = e.floatingEl;
      n.map((u) => {
        if (e.floatingEl)
          if (o.value)
            u.isIntersecting ? e.floatingEl.classList.remove(`${L}--visible`) : e.floatingEl.classList.add(`${L}--visible`);
          else {
            const E = s.parentElement === r, O = i.parentElement === r, g = u.target === s, p = u.target === i;
            E && g && !u.isIntersecting && !e.transitioning && (e.floatingEl.classList.add(`${L}--visible`), r.insertBefore(i, s), f.appendChild(s)), O && p && u.isIntersecting && !e.transitioning && (e.transitioning = !0, e.floatingEl.classList.remove(`${L}--visible`), setTimeout(() => {
              r.insertBefore(s, i), f.appendChild(i);
            }, 480), setTimeout(() => {
              e.transitioning = !1;
            }, 500));
          }
      });
    }
    $e(e, o);
    function a(n) {
      n.map((s) => {
        e.floatingEl && (s.isIntersecting ? e.floatingEl.classList.add(`${L}--footerRelative`) : e.floatingEl.classList.remove(`${L}--footerRelative`));
      });
    }
    Fe(e, t, o), Ae(e, a);
  },
  unmounted(e) {
    e.targetElIntersectionObserver && e.targetElIntersectionObserver.disconnect(), e.footerIntersectionObserver && e.footerIntersectionObserver.disconnect(), e.floatingEl && e.floatingEl.remove();
  }
}, oo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BodyScrollLock: H,
  CheckPosition: le,
  DetectScrollbar: de,
  EscapePress: ce,
  Floating: ze,
  Popover: ue,
  Tooltip: ie
}, Symbol.toStringTag, { value: "Module" })), Pe = {
  install(e) {
    e.config.globalProperties.$ga = { getDataEventValue: fe };
  }
}, Re = {
  install(e) {
    const o = Ee(), t = (a, n = o) => pe.sanitize(a, n);
    e.provide("sanitize", t);
  }
}, Ne = me(), Ve = {
  install(e) {
    e.provide("emitter", Ne);
  }
}, Ue = {
  install(e) {
    const o = m(!0), t = m(!0);
    e.provide("isDesktopApp", o), e.provide("isResizingBody", t);
    const a = () => {
      o.value = window.innerWidth > 1024;
    }, n = m(1920), s = ve((r) => {
      var u;
      const f = (u = r[0].borderBoxSize) == null ? void 0 : u[0].inlineSize;
      f !== n.value && (a(), t.value = !t.value, n.value = f);
    }, 50);
    let i = !1;
    e.mixin({
      mounted: () => {
        if (i)
          return;
        i = !0, a(), n.value = window.innerWidth, new ResizeObserver(s).observe(document.body, { box: "border-box" });
      }
    });
  }
}, no = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Emmitter: Ve,
  GoogleAnalyticsPlugin: Pe,
  IsDesktopApp: Ue,
  SanitizeHtmlPlugin: Re
}, Symbol.toStringTag, { value: "Module" })), We = ["onClick", "data-event"], qe = /* @__PURE__ */ M({
  __name: "IbarBurger",
  emits: ["open-menu"],
  setup(e, { emit: o }) {
    const t = () => {
      o("open-menu");
    };
    return (a, n) => (l(), d("button", {
      ref: "burger",
      class: "Ibar__burger",
      "aria-label": "Open Menu",
      onClick: _e(t, ["stop"]),
      "data-event": a.$ga.getDataEventValue("iBar", "btn", "openMenu")
    }, null, 8, We));
  }
}), He = {}, je = {
  class: "Ibar__logo__svg",
  viewBox: "0 0 2811 590",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ye = /* @__PURE__ */ he('<path class="Ibar__logo__text" d="M633.872 234.191h-42.674v-57.246h42.674c0-19.776 2.082-35.389 5.204-48.92 4.164-13.53 9.368-23.939 17.695-31.225 8.326-8.326 18.735-13.53 32.266-16.653 13.531-3.123 29.143-5.204 47.878-5.204h21.858c7.286 0 14.572 1.04 21.857 1.04v62.451c-8.326-1.041-16.653-2.082-23.939-2.082-10.408 0-17.694 1.041-23.939 4.164-6.245 3.122-9.368 10.408-9.368 22.898v13.531h53.083v57.246h-53.083v213.372h-89.512V234.191zM794.161 176.945h86.39v47.879h1.041c6.245-17.694 16.653-30.185 31.225-39.552 14.572-9.368 31.225-13.531 49.96-13.531h10.409c3.122 0 7.286 1.041 10.408 2.082v81.185c-6.245-2.082-11.449-3.122-16.653-4.163-5.204-1.041-11.449-1.041-16.654-1.041-11.449 0-20.816 2.082-29.143 5.204-8.327 3.123-15.613 8.327-20.817 14.572-5.204 6.245-10.408 12.49-12.49 20.817-3.123 8.326-4.163 15.612-4.163 23.939v133.228h-88.472V176.945h-1.041zM989.84 312.254c0-19.776 3.122-39.552 10.41-56.205 7.28-17.695 16.65-32.266 29.14-45.797 12.49-13.531 27.06-22.899 44.76-30.185 17.69-7.285 36.43-11.449 57.24-11.449 20.82 0 39.56 4.164 57.25 11.449 17.69 7.286 32.27 17.695 45.8 30.185 12.49 12.49 22.9 28.102 29.14 45.797 7.29 17.694 10.41 36.429 10.41 56.205 0 20.817-3.12 39.552-10.41 57.246-7.29 17.695-16.65 32.266-29.14 44.756-12.49 12.49-28.11 22.899-45.8 30.185-17.69 7.286-36.43 11.449-57.25 11.449-20.81 0-40.59-4.163-57.24-11.449-17.7-7.286-32.27-17.695-44.76-30.185-12.49-12.49-21.86-28.102-29.14-44.756-7.288-17.694-10.41-36.429-10.41-57.246zm88.47 0c0 8.327 1.04 17.694 3.12 26.021 2.09 9.368 5.21 16.653 9.37 23.939 4.16 7.286 9.37 13.531 16.65 17.695 7.29 4.163 15.62 7.285 26.03 7.285 10.4 0 18.73-2.081 26.02-7.285 7.28-4.164 12.49-10.409 16.65-17.695 4.16-7.286 7.29-15.612 9.37-23.939 2.08-9.368 3.12-17.694 3.12-26.021 0-8.327-1.04-17.694-3.12-26.021-2.08-9.368-5.21-16.653-9.37-23.939-4.16-7.286-9.37-13.531-16.65-17.695-7.29-5.204-15.62-7.285-26.02-7.285-10.41 0-18.74 2.081-26.03 7.285-7.28 5.205-12.49 10.409-16.65 17.695-4.16 7.286-7.28 15.612-9.37 23.939-2.08 9.368-3.12 17.694-3.12 26.021zM1306.25 176.945h86.39v37.47h1.04c4.17-7.286 9.37-13.531 15.62-18.735 6.24-5.204 13.53-10.408 20.81-14.572 7.29-4.163 15.62-7.286 23.94-9.367 8.33-2.082 16.66-3.123 24.98-3.123 22.9 0 40.6 4.164 53.09 11.449 13.53 7.286 22.89 16.654 29.14 27.062 6.24 10.409 10.41 21.858 12.49 34.348 2.08 12.49 2.08 22.898 2.08 33.307v172.779h-88.47V316.417v-27.061c0-9.368-1.04-16.654-4.16-23.94-3.13-7.286-7.29-12.49-13.53-16.653-6.25-4.164-15.62-6.245-27.07-6.245-8.32 0-15.61 2.081-21.85 5.204-6.25 3.122-11.45 7.286-14.58 13.531-4.16 5.204-6.24 11.449-8.32 18.735s-3.12 14.572-3.12 21.858v145.717h-88.48V176.945zM1780.88 234.19h-55.17v122.819c0 10.408 3.12 17.694 8.33 20.817 6.24 3.122 13.53 5.204 22.9 5.204 4.16 0 7.28 0 11.45-1.041h11.45v65.573c-8.33 0-15.62 1.041-23.94 2.082-8.33 1.04-16.66 1.041-23.94 1.041-18.74 0-34.35-2.082-46.84-5.205-12.49-3.122-21.86-8.326-29.14-15.612-7.29-7.286-12.49-16.654-14.58-29.144-3.12-12.49-4.16-27.062-4.16-45.797V234.19h-44.76v-57.246h44.76V94.717h88.47v82.227h55.17v57.246zM1902.66 143.639h-88.48V75.984h88.48v67.655zm-89.52 33.307h88.48v270.618h-88.48V176.946zM2024.43 334.111c1.04 18.735 6.25 33.307 16.66 44.756 10.4 11.449 24.98 16.653 43.71 16.653 10.41 0 20.82-2.081 30.19-7.286 9.36-5.204 16.65-12.49 20.81-22.898h83.27c-4.16 15.613-10.41 29.144-19.78 40.593-9.36 11.449-19.77 20.817-31.22 28.102-12.49 7.286-24.98 12.491-39.55 16.654-14.57 3.122-29.15 5.204-43.72 5.204-21.86 0-41.63-3.122-60.37-9.367-18.73-6.246-34.34-15.613-46.83-28.103-12.49-12.49-22.9-27.062-30.19-45.797-7.28-17.694-10.41-38.511-10.41-60.369 0-20.817 4.17-39.552 11.45-57.246 7.29-17.694 17.7-32.266 31.23-44.756 13.53-12.49 29.14-21.858 46.83-29.144 17.7-7.286 36.43-10.408 56.21-10.408 23.94 0 45.8 4.163 63.49 12.49 17.7 8.327 33.31 19.776 44.76 35.389 11.45 15.612 20.81 32.266 26.02 52.042 5.2 19.776 8.33 41.633 7.28 64.532h-199.84v-1.041zm110.33-49.961c-1.04-15.612-6.24-28.102-15.61-39.551-9.37-10.409-21.86-16.654-37.47-16.654s-28.1 5.204-38.51 15.613c-10.41 10.408-16.66 23.939-18.74 40.592h110.33zM2254.46 176.945h86.39v47.879h1.04c6.25-17.694 16.65-30.185 31.23-39.552 14.57-9.368 31.22-13.531 49.96-13.531h10.4c3.13 0 7.29 1.041 10.41 2.082v81.185c-6.24-2.082-11.45-3.122-16.65-4.163-5.21-1.041-11.45-1.041-16.65-1.041-11.45 0-20.82 2.082-29.15 5.204-8.32 3.123-15.61 8.327-20.81 14.572-6.25 6.245-10.41 12.49-12.49 20.817-3.13 8.326-4.17 15.612-4.17 23.939v133.228h-88.47V176.945h-1.04zM2534.45 359.091c0 7.286 1.04 12.49 4.16 17.694 3.12 5.204 6.24 9.368 10.41 12.49 4.16 3.123 9.36 5.204 14.57 7.286 6.24 2.082 11.45 2.082 17.69 2.082 4.17 0 8.33 0 13.53-2.082 5.21-1.041 9.37-3.123 13.53-5.204 4.17-2.082 7.29-5.204 10.41-9.368 3.13-4.163 4.17-8.327 4.17-13.531 0-5.204-2.09-9.367-5.21-12.49-3.12-3.122-7.28-6.245-11.45-8.327-4.16-2.081-9.36-4.163-14.57-5.204-5.2-1.041-9.37-2.081-13.53-3.122-13.53-3.123-28.1-6.245-42.67-9.368-14.58-3.122-28.11-7.286-40.6-12.49-12.49-6.245-22.9-13.531-30.18-23.939-8.33-10.409-11.45-23.94-11.45-42.675 0-16.653 4.16-30.184 11.45-40.592 8.33-10.409 17.69-18.736 30.18-24.981 12.49-6.245 26.02-10.408 40.6-13.53 14.57-3.123 28.1-4.164 41.63-4.164 14.57 0 29.14 1.041 43.71 4.164 14.58 2.081 27.07 7.285 39.56 13.53 12.49 6.245 21.85 15.613 29.14 27.062 7.29 11.45 11.45 26.021 12.49 43.716h-82.23c0-10.409-4.16-18.736-11.45-23.94-7.28-4.163-16.65-7.286-28.1-7.286-4.16 0-8.32 0-12.49 1.041-4.16 1.041-8.32 1.041-12.49 2.082-4.16 1.041-7.28 3.122-9.37 6.245-2.08 3.122-4.16 6.245-4.16 11.449 0 6.245 3.12 11.449 10.41 15.613 6.24 4.163 14.57 7.286 24.98 10.408 10.41 2.082 20.82 5.204 32.27 7.286 11.44 2.082 22.89 4.163 33.3 6.245 13.53 3.123 24.98 7.286 33.31 13.531 9.37 6.245 15.61 12.49 20.82 19.776 5.2 7.286 9.36 14.572 11.45 21.858 2.08 7.285 3.12 13.53 3.12 19.776 0 17.694-4.17 33.306-11.45 45.796-8.33 12.491-17.7 21.858-30.19 30.185-12.49 7.286-26.02 12.49-41.63 16.653-15.61 3.123-31.22 5.204-45.8 5.204-15.61 0-32.26-1.04-47.87-4.163-15.62-3.122-29.15-8.327-41.64-15.612a83.855 83.855 0 01-30.18-30.185c-8.33-12.49-12.49-28.102-12.49-46.838h84.31v-2.081z" fill="#FFFFFF"></path><path d="M0 481.911V281.028l187.351-58.287v200.882L0 481.911z" fill="#8BC53F"></path><path d="M187.351 423.623V222.741l126.983 87.431v200.882l-126.983-87.431z" fill="#EBD417"></path><path d="M126.982 569.341L0 481.911l187.351-58.287 126.983 87.43-187.352 58.287z" fill="#034EA1"></path><path d="M183.188 212.331l51.001-116.574 65.573 155.085-51.001 116.574-65.573-155.085z" fill="#712E74"></path><path d="M248.761 367.415l51.001-116.574 171.739-28.102-49.96 115.533-172.78 29.143z" fill="#009FD1"></path><path d="M299.762 250.842L234.189 95.757l171.739-28.103 65.573 155.085-171.739 28.103z" fill="#F6921E"></path><path d="M187.352 222.741L59.328 198.802 44.757 71.819 172.78 95.76l14.572 126.982z" fill="#DA2128"></path><path d="M172.78 95.758L44.757 71.818l70.777-70.776 128.023 23.94-70.777 70.776z" fill="#25BCBD"></path><path d="M258.129 153.005l-70.777 69.736-14.571-126.982 70.777-70.778 14.571 128.024z" fill="#00844A"></path>', 10), Ge = [
  Ye
];
function Ke(e, o) {
  return l(), d("svg", je, Ge);
}
const Je = /* @__PURE__ */ J(He, [["render", Ke]]), Qe = ["href", "aria-label", "data-event"], Ze = ["src", "alt"], Xe = { key: 2 }, X = /* @__PURE__ */ M({
  __name: "IbarLogo",
  props: {
    tenantLogo: { default: "" }
  },
  setup(e) {
    const o = e, t = m(!1), a = h(() => `//${F.getMainDomain}`), n = h(() => F.getIsFrontiers), s = h(() => F.getTenantName), i = h(() => !!(o.tenantLogo && !t.value)), r = () => {
      console.warn(`Error loading tenant logo with url: ${o.tenantLogo}`), t.value = !0;
    };
    return (f, u) => (l(), d("div", {
      class: B(["Ibar__logo", { "Ibar__logo--tenant": !n.value }])
    }, [
      v("a", {
        href: a.value,
        "aria-label": s.value + " homepage",
        class: "Ibar__logo__link",
        "data-event": f.$ga.getDataEventValue("iBar", "a", "home")
      }, [
        n.value ? (l(), I(Je, { key: 0 })) : i.value ? (l(), d("img", {
          key: 1,
          src: f.tenantLogo,
          alt: s.value,
          onError: r,
          class: "Ibar__logo__link__tenantLogo"
        }, null, 40, Ze)) : (l(), d("span", Xe, $(s.value), 1))
      ], 8, Qe)
    ], 2));
  }
}), et = ["href"], U = /* @__PURE__ */ M({
  __name: "IbarMainLink",
  props: {
    url: {},
    text: {}
  },
  setup(e) {
    const o = e, t = h(() => {
      let a = o.url;
      if (o.url.startsWith("http"))
        try {
          const n = new URL(o.url);
          n && n.pathname && (a = n.pathname);
        } catch (n) {
          console.warn(n);
        }
      return {
        Ibar__link: !0,
        "Ibar__link--active": location.pathname === a
      };
    });
    return (a, n) => (l(), d("a", {
      class: B(t.value),
      href: a.url
    }, $(a.text), 11, et));
  }
}), tt = ["href", "aria-label", "data-event"], ee = /* @__PURE__ */ M({
  __name: "IbarMyFrontiers",
  setup(e) {
    const o = m("My Frontiers"), t = m("/my-frontiers/overview");
    return N(() => {
      F.getIsFrontiers === !1 && (o.value = "My account"), t.value = F.getWwwAbsoluteUrl(
        "/my-frontiers/overview"
      );
    }), (a, n) => (l(), d("a", {
      class: "Ibar__icon Ibar__icon--list",
      href: t.value,
      "aria-label": o.value,
      "data-event": a.$ga.getDataEventValue("iBar", "a", "myFrontiers")
    }, [
      v("span", null, $(o.value), 1)
    ], 8, tt));
  }
}), ot = {
  key: 0,
  class: "Ibar__appName"
}, nt = {
  key: 1,
  class: "Ibar__appName__wrapper"
}, at = /* @__PURE__ */ v("li", { class: "Ibar__dropdown__about__block__title" }, "Select a product", -1), rt = ["href"], te = /* @__PURE__ */ M({
  __name: "BackofficeIbarAppName",
  props: {
    appName: {},
    products: { default: () => [] }
  },
  setup(e) {
    const o = e, t = h(() => o.products.length > 0), a = () => !1;
    return (n, s) => t.value ? (l(), d("div", nt, [
      y(Y, {
        title: n.appName,
        class: "Ibar__appName"
      }, {
        default: W(() => [
          v("ul", null, [
            at,
            (l(!0), d(P, null, R(n.products, (i, r) => (l(), d("li", { key: r }, [
              v("a", {
                href: i.url,
                class: B({ "Ibar__link--active": a() })
              }, $(i.name), 11, rt)
            ]))), 128))
          ])
        ]),
        _: 1
      }, 8, ["title"])
    ])) : (l(), d("div", ot, $(n.appName), 1));
  }
}), st = { class: "Ibar__wrapper" }, it = { class: "Ibar__mainLinks__wrapper" }, lt = /* @__PURE__ */ v("div", { class: "Ibar__spacer" }, null, -1), ut = /* @__PURE__ */ M({
  __name: "BackofficeIbarMain",
  props: {
    appName: {},
    products: { default: () => [] },
    officeSuiteItems: { default: () => [] },
    enabledOfficeTools: { type: Boolean, default: !1 },
    isOfficeToolsApiRequestFinished: { type: Boolean, default: !1 },
    toolsDropdown: { default: null },
    mainLinks: { default: () => [] },
    isAnonymousUser: { type: Boolean, default: !1 },
    helpCenterLink: {},
    tenantLogo: { default: "" }
  },
  emits: ["open-menu"],
  setup(e, { emit: o }) {
    const t = e, a = m(-1), n = m(), s = m(), i = m(), r = h(() => t.isOfficeToolsApiRequestFinished && !t.enabledOfficeTools), f = h(() => t.mainLinks.slice(0, a.value)), u = h(() => t.mainLinks.slice(a.value)), E = h(() => u.value.length > 0), O = h(() => ({
      Ibar__mainLinks__showMore: !0,
      "Ibar__mainLinks__showMore--active": g.value !== "More"
    })), g = h(() => {
      let c = "More", k = null;
      for (let b = 0; b < u.value.length; b++) {
        const x = u.value[b];
        location.pathname === x.url && (k = x);
      }
      return k !== null && (c = k.text), c;
    });
    D(
      () => t.products,
      () => {
        T(t.products);
      }
    ), D(
      () => t.officeSuiteItems,
      () => {
        T(t.officeSuiteItems);
      }
    ), D(
      () => t.mainLinks,
      () => {
        T(t.mainLinks);
      }
    );
    const p = (c) => {
      const k = s.value;
      k && (k.style.zIndex = c ? "" : "130");
    }, A = () => {
      const c = s.value;
      c && (c.style.zIndex = "");
    }, _ = () => {
      o("open-menu");
    }, T = (c) => {
      c.length > 0 && (S(), V());
    }, S = () => {
      a.value = t.mainLinks.length;
    }, V = () => new Promise((c, k) => {
      if (!Q.isDesktop() || t.mainLinks.length === 0)
        a.value = t.mainLinks.length, c();
      else {
        const b = i.value;
        if (b.parentElement) {
          const x = b.parentElement;
          x.style.overflow = "hidden";
          const ne = setInterval(() => {
            const ae = b.scrollWidth, re = b.offsetWidth;
            ae > re ? a.value -= 1 : (clearInterval(ne), x.style.overflow = "", c());
          }, 0);
        } else
          k("Main links parentElement was not found");
      }
    }), oe = (c) => {
      c.isTrusted && (S(), V());
    };
    return N(() => {
      n.value = Ce(oe, 300), window.addEventListener("resize", n.value), setTimeout(() => {
        S(), V();
      }, 100);
    }), ge(() => {
      window.removeEventListener("resize", n.value);
    }), (c, k) => (l(), d("div", {
      ref_key: "ibar",
      ref: s,
      class: "Ibar__main"
    }, [
      v("div", st, [
        y(w(qe), {
          "parent-data-event": "boiBar",
          onOpenMenu: _
        }),
        y(w(X), {
          "parent-data-event": "boiBar",
          "tenant-logo": c.tenantLogo
        }, null, 8, ["tenant-logo"]),
        y(te, {
          "app-name": c.appName,
          products: c.products
        }, null, 8, ["app-name", "products"]),
        v("div", it, [
          v("div", {
            ref_key: "mainLinksRef",
            ref: i,
            class: "Ibar__mainLinks"
          }, [
            (l(!0), d(P, null, R(f.value, (b, x) => (l(), I(w(U), {
              key: x,
              url: b.url,
              text: b.text
            }, null, 8, ["url", "text"]))), 128)),
            E.value ? (l(), d("div", {
              key: 0,
              class: B(O.value)
            }, [
              y(Y, { title: g.value }, {
                default: W(() => [
                  v("ul", null, [
                    (l(!0), d(P, null, R(u.value, (b, x) => (l(), d("li", { key: x }, [
                      y(w(U), {
                        url: b.url,
                        text: b.text
                      }, null, 8, ["url", "text"])
                    ]))), 128))
                  ])
                ]),
                _: 1
              }, 8, ["title"])
            ], 2)) : C("", !0)
          ], 512)
        ]),
        lt,
        c.isAnonymousUser ? C("", !0) : (l(), I(w(ee), {
          key: 0,
          "parent-data-event": "boiBar"
        })),
        c.enabledOfficeTools && c.toolsDropdown ? (l(), I(G, {
          key: 1,
          "tools-dropdown": c.toolsDropdown
        }, null, 8, ["tools-dropdown"])) : C("", !0),
        r.value ? (l(), I(K, {
          key: 2,
          "office-suite-items": c.officeSuiteItems
        }, null, 8, ["office-suite-items"])) : C("", !0),
        y(ke, {
          "parent-data-event": "boiBar",
          "help-center-link": c.helpCenterLink,
          onOpen: p,
          onClose: A
        }, null, 8, ["help-center-link"])
      ])
    ], 512));
  }
}), ct = ["onKeydown"], dt = { class: "Ibar__menu__header" }, ft = ["data-event"], pt = { class: "Ibar__menu__wrapper" }, mt = /* @__PURE__ */ M({
  __name: "BackofficeIbarMenu",
  props: {
    isOpen: { type: Boolean, default: !1 },
    appName: {},
    products: { default: () => [] },
    officeSuiteItems: { default: () => [] },
    enabledOfficeTools: { type: Boolean, default: !1 },
    isOfficeToolsApiRequestFinished: { type: Boolean, default: !1 },
    toolsDropdown: { default: null },
    mainLinks: { default: () => [] },
    isAnonymousUser: { type: Boolean, default: !0 },
    tenantLogo: { default: "" }
  },
  emits: ["update:isOpen"],
  setup(e, { emit: o }) {
    const t = e, a = h(() => t.isOfficeToolsApiRequestFinished && !t.enabledOfficeTools), n = () => {
      Q.isDesktop() || s();
    }, s = () => {
      o("update:isOpen", !1);
    }, i = (r) => r.key === "Escape" && s();
    return N(() => {
      document && document.addEventListener("keydown", i);
    }), be(() => {
      document && document.removeEventListener("keydown", i);
    }), (r, f) => (l(), I(w(Me), { onTrigger: n }, {
      default: W(() => [
        j((l(), d("div", {
          class: B(["Ibar__menu", {
            "Ibar__menu--open": r.isOpen
          }]),
          onKeydown: ye(s, ["esc"])
        }, [
          v("div", dt, [
            y(w(X), {
              "parent-data-event": "boiBarMenu",
              "tenant-logo": r.tenantLogo
            }, null, 8, ["tenant-logo"]),
            v("button", {
              class: "Ibar__close",
              "aria-label": "Close Menu",
              onClick: s,
              "data-event": r.$ga.getDataEventValue("boiBarMenu", "btn", "closeMenu")
            }, null, 8, ft)
          ]),
          v("div", pt, [
            v("div", null, [
              y(te, {
                "app-name": r.appName,
                products: r.products
              }, null, 8, ["app-name", "products"]),
              (l(!0), d(P, null, R(r.mainLinks, (u) => (l(), I(w(U), {
                key: u.text,
                url: u.url,
                text: u.text,
                "data-event": r.$ga.getDataEventValue("iBar", "a", u.text)
              }, null, 8, ["url", "text", "data-event"]))), 128))
            ]),
            v("div", null, [
              r.isAnonymousUser ? C("", !0) : (l(), I(w(ee), {
                key: 0,
                "parent-data-event": "boiBar"
              })),
              r.enabledOfficeTools && r.toolsDropdown ? (l(), I(G, {
                key: 1,
                "tools-dropdown": r.toolsDropdown
              }, null, 8, ["tools-dropdown"])) : C("", !0),
              a.value ? (l(), I(K, {
                key: 2,
                "office-suite-items": r.officeSuiteItems,
                "is-devices": !0
              }, null, 8, ["office-suite-items"])) : C("", !0)
            ])
          ])
        ], 42, ct)), [
          [
            w(H),
            r.isOpen,
            void 0,
            { noDelay: !0 }
          ]
        ])
      ]),
      _: 1
    }));
  }
}), vt = { class: "BackofficeIbar" }, _t = { class: "Ibar" }, ao = /* @__PURE__ */ M({
  __name: "BackofficeIbar",
  props: {
    appName: {},
    mainLinks: { default: () => [] },
    helpCenterLink: {},
    tenantLogo: { default: "" }
  },
  setup(e) {
    const o = m(!1), t = m(!1), a = m(null), n = m(!1), s = m(!1), i = m(), r = m([]), f = m([]), u = h(() => s.value === !1 || i.value === void 0), E = () => {
      o.value = !0;
    }, O = () => {
      new xe().getToolsItems().then((p) => {
        a.value = p, r.value = p.products, t.value = p.enabledOfficeTools || !1, f.value = p.officeSuites;
      }).catch((p) => {
        console.warn("Next Journal Pages API error: ", p);
      }).finally(() => {
        n.value = !0;
      });
    };
    return N(() => {
      new Le().getLoggedUserInfo().then((p) => {
        i.value = p, p !== void 0 && O();
      }).catch((p) => {
        console.warn("User API error: ", p);
      }).finally(() => {
        s.value = !0;
      });
    }), (g, p) => (l(), d("div", vt, [
      v("nav", _t, [
        y(ut, {
          "app-name": g.appName,
          products: r.value,
          "office-suite-items": f.value,
          "enabled-office-tools": t.value,
          "tools-dropdown": a.value,
          "is-office-tools-api-request-finished": n.value,
          "main-links": g.mainLinks,
          "is-anonymous-user": u.value,
          "help-center-link": g.helpCenterLink,
          "tenant-logo": g.tenantLogo,
          onOpenMenu: E
        }, null, 8, ["app-name", "products", "office-suite-items", "enabled-office-tools", "tools-dropdown", "is-office-tools-api-request-finished", "main-links", "is-anonymous-user", "help-center-link", "tenant-logo"]),
        y(mt, {
          "is-open": o.value,
          "app-name": g.appName,
          products: r.value,
          "office-suite-items": f.value,
          "enabled-office-tools": t.value,
          "tools-dropdown": a.value,
          "is-office-tools-api-request-finished": n.value,
          "main-links": g.mainLinks,
          "is-anonymous-user": u.value,
          "tenant-logo": g.tenantLogo,
          "onUpdate:isOpen": p[0] || (p[0] = (A) => o.value = !1)
        }, null, 8, ["is-open", "app-name", "products", "office-suite-items", "enabled-office-tools", "tools-dropdown", "is-office-tools-api-request-finished", "main-links", "is-anonymous-user", "tenant-logo"])
      ])
    ]));
  }
});
const ht = {}, gt = { class: "CardWrapper" };
function bt(e, o) {
  return l(), d("div", gt, [
    Ie(e.$slots, "default")
  ]);
}
const ro = /* @__PURE__ */ J(ht, [["render", bt]]), yt = { class: "Textarea__labelWrapper" }, It = ["for"], wt = ["id", "maxlength", "disabled", "readonly"], so = /* @__PURE__ */ M({
  __name: "Textarea",
  props: {
    id: {},
    label: {},
    modelValue: {},
    isDisabled: { type: Boolean, default: !1 },
    isReadonly: { type: Boolean, default: !1 },
    errorMessage: {},
    maxlength: {},
    forceFocus: { type: Boolean },
    forceBlur: { type: Boolean },
    showClearIcon: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "focus", "blur", "clear"],
  setup(e, { emit: o }) {
    const t = e, a = m(null), n = m(!1), s = h({
      get: () => t.modelValue,
      set: (_) => {
        o("update:modelValue", _);
      }
    }), i = h(() => !!t.modelValue), r = h(() => t.errorMessage ? t.errorMessage.length > 0 : !1), f = h(() => ({
      "Textarea--enabled": n.value || i.value,
      "Textarea--disabled": t.isDisabled === !0,
      "Textarea--readonly": t.isReadonly === !0,
      "has-error": r.value === !0
    })), u = () => {
      s.value = "", o("clear");
    }, E = () => {
      n.value = !0, o("focus");
    }, O = () => {
      n.value = !1, o("blur");
    }, g = (_) => {
      _ && _.target && o("update:modelValue", _.target.value);
    }, p = () => {
      a.value.focus();
    }, A = () => {
      a.value.blur();
    };
    return D(
      () => t.forceFocus,
      () => {
        p();
      }
    ), D(
      () => t.forceBlur,
      () => {
        A();
      }
    ), (_, T) => (l(), d("div", null, [
      v("div", {
        class: B(["Textarea", f.value])
      }, [
        v("span", yt, [
          v("label", {
            for: _.id,
            class: "Textarea__label"
          }, $(_.label), 9, It)
        ]),
        j(v("textarea", {
          class: B(["Textarea__field", { "Textarea__field--WithShowClearIcon": _.showClearIcon }]),
          ref_key: "textareaEl",
          ref: a,
          id: _.id,
          "onUpdate:modelValue": T[0] || (T[0] = (S) => s.value = S),
          onInput: g,
          onFocus: E,
          onBlur: O,
          maxlength: _.maxlength,
          disabled: _.isDisabled,
          readonly: _.isReadonly
        }, `\r
      `, 42, wt), [
          [we, s.value]
        ]),
        _.showClearIcon && s.value ? (l(), d("i", {
          key: 0,
          class: "Textarea__appendIcon",
          onClick: u,
          onMousedown: T[1] || (T[1] = (S) => S.preventDefault())
        }, null, 32)) : C("", !0)
      ], 2),
      r.value ? (l(), I(Te, {
        key: 0,
        message: _.errorMessage
      }, null, 8, ["message"])) : C("", !0)
    ]));
  }
});
export {
  F as $frontiersClibConfig,
  Ho as Accordion,
  jo as AccordionItem,
  go as AffiliationList,
  oa as Alert,
  na as AlertType,
  Go as AlphabetDropDown,
  Qo as Avatar,
  Zo as AvatarColor,
  Xo as AvatarSize,
  ao as BackofficeIbar,
  ma as Banner,
  tn as Breadcrumbs,
  bo as Browsers,
  nn as Button,
  an as ButtonColor,
  zo as ButtonFiltersContainer,
  La as ButtonIcon,
  Ca as ButtonIconColor,
  rn as ButtonIconLocation,
  Ma as ButtonIconSize,
  sn as ButtonSize,
  ln as ButtonType,
  Wn as Card,
  da as CardA,
  fa as CardASkin,
  ar as CardArticle,
  cr as CardB,
  Ya as CardDownload,
  Jn as CardEditor,
  Ga as CardGrid,
  yo as CardJournal,
  Ka as CardPostNew,
  Ja as CardRT,
  Io as CardRT2,
  Zn as CardSubject,
  ro as CardWrapper,
  _a as Carousel,
  Ua as Checkbox,
  Na as ChipFilter,
  Wa as ChipSelect,
  ra as CreateCommonOrganization,
  sa as CreateOrganization,
  cn as CustomLink,
  sr as DateRangePicker,
  oo as Directives,
  fo as DropDown,
  Po as EFilterType,
  Mr as EnumParser,
  hn as ExpandablePanel,
  uo as Fair2DataPortalIcon,
  mr as FeedbackIcon,
  wo as FiguresOutline,
  ko as FiguresOutlineItem,
  ga as FilterCardListB,
  yn as Footer,
  Za as FrontiersIcon,
  wn as FrontiersImage,
  kn as FrontiersImageMedia,
  xn as FrontiersImageOrientation,
  Mn as FrontiersVideo,
  Pe as GoogleAnalyticsPlugin,
  ea as GoogleRecaptcha,
  No as Ibar,
  Hn as ImageViewer,
  xo as InfoDrawer,
  or as Input,
  Lo as Lightbox,
  dn as LinkColor,
  fn as LinkIcon,
  pn as LinkIconLocation,
  mn as LinkSize,
  vn as LinkType,
  Yn as MainHeader,
  Gn as MainHeaderEnum,
  ya as MessagesCarousel,
  Ia as MessagesCarouselItem,
  Do as Modal,
  ka as Newsletter,
  xe as NextJournalPagesService,
  ia as OrganizationType,
  Co as Outline,
  Vn as Pagination,
  Mo as PeopleList,
  To as PeopleListItem,
  no as Plugins,
  Sn as QuickFilters,
  Bn as QuickFiltersItem,
  fr as RadioInputList,
  Q as Resolutions,
  er as SearchBar,
  Ha as Segment,
  po as SelectedItemEventTrigger,
  _r as SlidingPanel,
  Sa as Snackbar,
  Ba as SnackbarManager,
  $n as SocialMediaFeed,
  Dn as SocialMediaFeedEmit,
  An as SocialMediaFeedProvider,
  Pa as Spinner,
  Aa as Tabs,
  Ea as Tag,
  Pn as TagCloud,
  Rn as TagCloudHeadingsEnum,
  so as Textarea,
  Eo as ToolbarContextual,
  ie as Tooltip,
  la as UgaritInput,
  ua as UgaritService,
  Le as UserService,
  Te as ValidationMessage,
  Tn as VideoProvider,
  En as VideoRatio,
  Kt as addPackageToWindowFrontiers,
  Br as addThousands,
  gr as areDatesEqual,
  Fa as clearAllSnackbarNotification,
  Xt as convertUTCtoCET,
  Yt as copyToClipboard,
  $a as createSnackbarNotification,
  br as dateToString,
  yr as daysOfTheWeek,
  Ne as emitter,
  ir as findPresetIndex,
  Dr as formatCountSuffix,
  Ko as getAlphabetLetters,
  fe as getDataEventValue,
  lr as getDefaultPresetRanges,
  se as getFirstChildWithRelativePosition,
  mo as getFormatText,
  q as getHashSafely,
  Ir as getMonthName,
  wr as getMonthlyCalendar,
  jt as getOrdinalSuffix,
  Vo as getProfilePicture,
  vo as getPropertyValue,
  Ee as getSanitizeOptions,
  eo as getScrollbarWidth,
  Jt as getShadowDomRoot,
  to as getTargetByUrlUnderMainDomain,
  Er as getURL,
  Ht as getUserInitials,
  _o as highlightText,
  Oe as isAbsoluteURL,
  Se as isRelativeURL,
  Be as isUrlUnderDomain,
  Fr as isValidNumber,
  Or as linkClickHandler,
  Oo as mapPeopleToPeopleAffiliations,
  kr as monthNames,
  xr as monthNumber,
  Zt as numberFormatter,
  Lr as parseDate,
  Gt as routerScrollBehavior,
  Wo as sleep,
  Ln as toKebabCase,
  gn as toPascalCase,
  So as useActiveIdOnSections,
  Bo as useActiveIdOnSectionsGSAP,
  Fo as useHasScrollbar,
  Qt as waitFor
};
